export default __webpack_public_path__ + "static/media/Platinum suites.ee2cf46c.png";